import { NavLink, useLocation } from 'react-router-dom'
import { ShoppingCart, Package, BookOpen, User, PlusCircle } from 'lucide-react'

export default function NavBar() {
    const location = useLocation()
    const isShoppingMode = location.pathname.startsWith('/shopping/')

    if (isShoppingMode) return null

    return (
        <nav className="bottom-nav">
            <NavLink to="/app" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} end>
                <ShoppingCart />
                <span>Listes</span>
            </NavLink>
            <NavLink to="/generate" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <PlusCircle />
                <span>Générer</span>
            </NavLink>
            <NavLink to="/inventory" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <Package />
                <span>Inventaire</span>
            </NavLink>
            <NavLink to="/recipes" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <BookOpen />
                <span>Recettes</span>
            </NavLink>
            <NavLink to="/profile" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <User />
                <span>Profil</span>
            </NavLink>
        </nav>
    )
}
